import styled, { css } from "styled-components"

import { NavLink } from "components/common/NavLink"

export const MENU_CLOSED_WIDTH = "64px"
export const MENU_OPEN_WIDTH = "212px"
const TRANSITION_DURATION = "0.25s"
const TRANSITION_EASING = "cubic-bezier(0.4, 0, 0.2, 1)"
const MOBILE_TRANSITION = "0.1s"
const MOBILE_BREAKPOINT = "768px"

export const MobileOverlay = styled.div<{ $isOpen: boolean }>`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
    transition: all ${MOBILE_TRANSITION} ease-in-out;
  }
`

export const StyledNav = styled.nav<{ $isOpen: boolean }>`
  position: fixed;
  left: 0;
  top: 64px;
  height: calc(100vh - 64px);
  background: transparent;
  z-index: 1999;
  display: flex;
  flex-direction: column;
  padding: 24px 12px 10px 15px;
  width: ${({ $isOpen }) => ($isOpen ? MENU_OPEN_WIDTH : MENU_CLOSED_WIDTH)};
  transition:
    width ${TRANSITION_DURATION} ${TRANSITION_EASING},
    transform ${TRANSITION_DURATION} ${TRANSITION_EASING};
  overflow: hidden;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    top: 0;
    height: 100vh;
    background: linear-gradient(90deg, #627afa 3.88%, #4ae9ff 94.88%);
    width: 0;
    padding: 64px 0 0;
    transition: all ${MOBILE_TRANSITION} ease-in-out;
    transform: none;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        width: 265px;
        padding: 64px 16px 0;
      `}
  }
`

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MenuIcon = styled.span`
  height: 24px;
  flex-shrink: 0;
  transition: fill 0.2s ease;

  svg {
    height: 24px;
    fill: #fff;
    transition: fill 0.2s ease;

    path {
      fill: inherit;
    }
  }
`

export const MenuIconStroke = styled(MenuIcon)`
  svg {
    fill: none;
    stroke: #fff;
    transition: stroke 0.2s ease;
  }
`

export const MenuText = styled.span<{ $isOpen: boolean }>`
  margin-left: 12px;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: opacity ${TRANSITION_DURATION} ${TRANSITION_EASING};
`

export const RedDot = styled.span<{ $isOpen: boolean }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 9px;
  background: rgb(215, 61, 61);
  font-size: 10px;
  color: #fff;
  flex-shrink: 0;
  transition: all ${TRANSITION_DURATION} ${TRANSITION_EASING};

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          min-width: 18px;
          height: 18px;
          padding: 0 4px;
          margin-left: auto;
          position: static;
        `
      : css`
          position: absolute;
          top: 4px;
          left: 26px;
          min-width: 14px;
          height: 14px;
          padding: 0 3px;
          font-size: 9px;
        `}
`

const menuItemStyles = css`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 24px;
  font-family: "Inter";
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
  min-height: 36px;
  min-width: 46px;
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`

const activeStyles = css`
  background: #fff;
  color: #52c2fd;

  ${MenuIcon} svg {
    fill: #52c2fd;
  }

  ${MenuIconStroke} svg {
    fill: none;
    path {
      stroke: #52c2fd;
    }
  }
`

export const StyledNavLink = styled(NavLink)`
  ${menuItemStyles}

  &.active {
    ${activeStyles}
  }
`
